<!--
 * @Author: 
 * @LastEditTime: 2023-01-12 10:09:24
 * @Description: 
-->
<template>
  <div class="w-full h-full">
    <div class="w-full h-full" id="graphContainer"></div>
  </div>
</template>

<script>
import { Graph } from '@antv/x6'

export default {
  name: 'manhattanGraph',
  props: {
    nodes: {
      type: Array,
      default: () => {
        return []
      },
      required: true,
    }, // 节点数据
    edges: {
      type: Array,
      default: () => {
        return []
      },
      required: true,
    }, // 边数据
  },
  data() {
    return {
      graph: null,
      graphData: {
        nodes: [], // 节点
        edges: [], // 边
      },
    }
  },
  methods: {
    /**
     * @description 初始化一个Graph对象，并指定一个页面上的绘图容器
     */
    initGraph() {
      const graph = new Graph({
        container: document.getElementById('graphContainer'), // 指定容器
        panning: true, // 是否启用画布平移功能
        autoResize: true, // 是否监听容器大小改变，并自动更新画布大小
        mousewheel: true, // 缩放画布(当启用scroller后是滚动画布)
        enabled: true,
        // interacting: {
        //   nodeMovable: false,
        // },
        background: {
          color: '#fffbe6',
        }, // 画布背景色
      })
      graph.fromJSON(this.graphData) // 渲染画布
      this.graph = graph
      this.addNodesAddEdges(this.graphData.nodes, this.graphData.edges)
    },

    /**
     * @description 将节点和边添加到画布中
     * @param {Array} nodes 节点数据(二维数组)
     * @param {Array} edges 边数据
     */
    addNodesAddEdges(nodes, edges) {
      console.log('nodes, edges2', nodes, edges)
      const nodesArr = nodes.flat(2) // 数据扁平化
      _.forEach(nodesArr, (nodeItem) => {
        this.graph.addNode(nodeItem) // 画布添加节点
      })
      _.forEach(edges, (edgeItem) => {
        this.graph.addEdge(edgeItem) // 画布添加边
      })
      this.graph.centerContent() // 内容在画布上居中
    },
  },
  created() {
    this.graphData.nodes = _.cloneDeep(this.nodes)
    this.graphData.edges = _.cloneDeep(this.edges)
  },
  mounted() {
    this.initGraph()
  },
}
</script>

<style lang="scss" scoped>

</style>
